import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import { CommonTable } from 'gnos-tables'

import { LOCALE_PREFIX } from '../../../../../Blocks/PaymentComparison/constants'
import CustomDate from '../../../../../../../../../../../../components/CustomDate'

import './style.scss'
import CellStyleWrapper from '../../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'

@injectIntl
export default class DataTAble extends Component {
    static propTypes = {
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
    }

    render() {
        const { id, data, intl } = this.props

        return (
            <div className={'payment-comparison-data-table'}>
                <CommonTable
                    key={`payment-comparison-common-table-${id}`}
                    id={`payment-comparison-common-table-${id}`}
                    columnsDefinition={[
                        {
                            accessor: 'date',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.date` }),
                            Cell: (date) => (
                                <CellStyleWrapper isCentered isJustifiedToCenter>
                                    <CustomDate date={date?.value?.value} precision={date?.value?.precision} />
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            accessor: 'paymentIndex',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.paymentIndex` }),
                            headerClassnames: ['payment-index-header'],
                            Cell: (row) => (
                                <CellStyleWrapper isCentered isJustifiedToCenter>
                                    {typeof row?.value === 'number' ? row.value : '-'}
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            accessor: 'sectorPaymentIndex',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.sectorPaymentIndex` }),
                            headerClassnames: ['sector-payment-index-header'],
                            Cell: (row) => (
                                <CellStyleWrapper isCentered isJustifiedToCenter>
                                    {typeof row?.value === 'number' ? row.value : '-'}
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            accessor: 'clubPaymentIndex',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.clubPaymentIndex` }),
                            headerClassnames: ['club-payment-index-header'],
                            Cell: (row) => (
                                <CellStyleWrapper isCentered isJustifiedToCenter>
                                    {typeof row?.value === 'number' ? row.value : '-'}
                                </CellStyleWrapper>
                            ),
                        },
                        {
                            accessor: 'supplierPaymentIndex',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.supplierPaymentIndex` }),
                            headerClassnames: ['supplier-payment-index-header'],
                            Cell: (row) => (
                                <CellStyleWrapper isCentered isJustifiedToCenter>
                                    {typeof row?.value === 'number' ? row.value : '-'}
                                </CellStyleWrapper>
                            ),
                        },
                    ]}
                    staticData={{
                        _table: data || [],
                    }}
                />
            </div>
        )
    }
}
